import React from 'react';
import { POSTS } from '../../../mocks/posts';

const BlogSection: React.FC = () => {
  const latestPosts = POSTS.slice(0, 3);

  const navigateToBlog = (slug?: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(slug ? `/blog/${slug}` : '/blog');
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#214134] mb-4">
            Últimos artigos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Tire dúvidas comuns antes de falar com a advogada.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {latestPosts.map((post) => (
            <article
              key={post.slug}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-200 hover:-translate-y-1 focus-within:ring-2 focus-within:ring-[#cc9b3f] focus-within:ring-offset-2 cursor-pointer"
              onClick={() => navigateToBlog(post.slug)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  navigateToBlog(post.slug);
                }
              }}
              tabIndex={0}
              role="button"
              aria-label={`Ler artigo: ${post.title}`}
            >
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#214134] mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <time dateTime={post.dateISO}>
                    {new Date(post.dateISO).toLocaleDateString('pt-BR', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric',
                    })}
                  </time>
                  <span>Tempo de leitura: {post.readingTimeMinutes} min</span>
                </div>
                <button
                  className="text-[#cc9b3f] hover:text-[#214134] font-medium transition-colors duration-150 whitespace-nowrap"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigateToBlog(post.slug);
                  }}
                  aria-label={`Ler artigo completo: ${post.title}`}
                >
                  Ler artigo
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center">
          <button
            onClick={() => navigateToBlog()}
            className="text-[#cc9b3f] hover:text-[#214134] font-medium transition-colors duration-150 cursor-pointer whitespace-nowrap"
            aria-label="Ver todos os artigos do blog"
          >
            Ver todos
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>

      <style>{`
        @media (prefers-reduced-motion: reduce) {
          article {
            transition: none !important;
          }
          article:hover {
            transform: none !important;
          }
        }
      `}</style>
    </section>
  );
};

export default BlogSection;
